import * as angular from 'angular';
import * as _ from 'lodash';

import { ITicketTypesService } from '../../services';
import { TicketType } from '../../models';
import { Store, Dispatcher, Dispatch } from '../Store';
import * as CONSTANTS from './ticketTypes.constants';


export interface ITicketTypesActionsService {
    getAll(): Dispatcher<TicketType[]>;
    getAll(force: boolean): Dispatcher<TicketType[]>;
}

export class TicketTypesActionsService implements ITicketTypesActionsService {
    static serviceId = 'ticketTypesActionsService';
    static $inject = ['$q', 'ticketTypesService'];

    constructor(
        private _$q: angular.IQService,
        private _ticketTypesService: ITicketTypesService
    ) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean): Dispatcher<TicketType[]> {
        return (dispatch: Dispatch<TicketType[]>, getState: () => Store) => {
            const { ticketTypes } = getState();
            if (force || (!ticketTypes.isLoading && !ticketTypes.isLoaded)) {
                dispatch({ type: CONSTANTS.TICKET_TYPES_LOAD });
                return this._ticketTypesService.getAll(force)
                    .then(data => {
                        dispatch({ type: CONSTANTS.TICKET_TYPES_LOAD_SUCCESS, payload: data });
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: CONSTANTS.TICKET_TYPES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<TicketType>(ticketTypes.dictionary));
            }
        };
    }
}